import Vue from 'vue'

const state = () => {
  return {
    selected: null,
    list: []
  }
}

const getters = {
  selected: state => {
    let board = state.list.find(board => board.slug === state.selected)
    //let board = state.list[state.selected]
    return board
  },
  boardIds: state => {
    return state.list.map(b => b._id)
  },
  public: state => {
    return state.list.filter(board => board.public)
  },
  private: state => {
    return state.list.filter(board => !board.public)
  }
}

const mutations = {
  SELECT_BOARD (state, slug) {
    //console.log(`settings slug to ${slug}`)
    //let index = state.list.findIndex(board => board.slug === slug)
    state.selected = slug
  },
  UNSELECT_BOARD (state, slug) {
    state.selected = null
  },
  SET_BOARDS (state, boards) {
    state.list = [...boards]
  },
  ADD_BOARD (state, board) {
    state.list.push(board)
  },
  UPDATE_BOARD (state, board) {
    let boardIndex = state.list.findIndex(b => b.slug === board.slug)

    Vue.set(state.list, boardIndex, board)
    //state.list[boardIndex] = board
  },
  DELETE_BOARD (state, slug) {
    let boardIndex = state.list.findIndex(b => b.slug === slug)

    state.list.splice(boardIndex, 1)
  }
}

const actions = {

  async getBoards ({ commit }, slug) {
    try {
      let { data } = await Vue.axios.get('boards')
      commit('SET_BOARDS', data)
      return data
    } catch (error) {

    }
  },
  async postBoard ({ commit }, board) {
    try {
      let { data } = await Vue.axios.post('boards', board)
      commit('ADD_BOARD', data)
      return data
    } catch (error) {
      throw (error.response.data.error)
    }
  },

  async receiveNewBoard({commit}, board) {
    commit('ADD_BOARD', board)
  },

  async updateBoard ({ getters, commit }, updates) {
    try {
      let slug = getters.selected.slug
      console.log("slug", slug)
      let { data } = await Vue.axios.put(`board/${slug}`, updates)
      //console.log(data)
      commit('UPDATE_BOARD', data)
    } catch (error) {
      throw (error.response.data.error)
    }
  },

  async receiveUpdatedBoard({commit}, board) {
    commit('UPDATE_BOARD', board)
  },

  async deleteBoard ({ commit }, slug) {
    try {
      let { data } = await Vue.axios.delete(`board/${slug}`)
      //console.log(data)
      commit('DELETE_BOARD', slug)
    } catch (error) {

    }
  },

  async receiveDeletedBoard({commit}, board) {
    commit('DELETE_BOARD', board.slug)
  },

}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
